<div class="d-flex flex-column justify-content-center align-items-end">
  <div class="flex-100 flex-fill text-right">
    <button mat-raised-button color="primary" matTooltip="Close" (click)="close()">
      Close
    </button>
  </div>
  <div class="flex-100 flex-fill nop-content afterpay-content">
    <div [innerHtml]="data?.content"></div>
  </div>
